import { useTranslation } from 'react-i18next';
import TenantPage from 'components/common/TenantPage';
import { useParams } from 'react-router-dom';
import AccessorForm from '../AccessorForm';
import { isTenantAdministrator } from 'components/helpers/IsTenantAdministrator';
import ConfirmEquipmentSwitchDialog from '../components/ConfirmEquipmentSwitchDialog';
import { useAccessorEditor } from '../hooks';

export function EditAccessor() {
  const translationPrefix = 'pages.accessories.edit';
  const { accessorId } = useParams();
  const isDisabledEdit = !isTenantAdministrator();
  const { t } = useTranslation();
  const {
    accessor,
    confirmSwitchOpen,
    persistAccessorUpdate,
    handleConfirmSwitch,
    handleCancelSwitch
  } = useAccessorEditor({ accessorId });
  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <AccessorForm
        accessor={accessor}
        onSubmit={persistAccessorUpdate}
        isDisabledEdit={isDisabledEdit}
      />
      <ConfirmEquipmentSwitchDialog
        open={confirmSwitchOpen}
        onCancel={handleCancelSwitch}
        onConfirm={handleConfirmSwitch}
      />
    </TenantPage>
  );
}

export default EditAccessor;
